<div
  class="mosaic-item"
  [class.changed]="data.changed"
  [style.border]="border"
  [style.borderColor]="borderColor"
  [style.boxShadow]="boxShadow"
  [attr.roi-id]="data.roiId"
  #cropElement
>
  <ts-image [url]="data.url">
    <div loader class="loading"></div>
    <!-- Projected unconditionally: a structural directive on a projected element
    is matched by the template it desugars into, not by this attribute. -->
    <div svg-overlay class="roi-overlay">
      <ng-container *ngIf="data.roiBox as box">
        <!-- A point of interest has no area to frame, so it gets the same mark the viewer
        gives it (`addPOIStyle`), at its own place in the crop - the centre, unless the crop
        was clamped at an image edge. -->
        <i
          *ngIf="isPoint(box); else roiBox"
          class="roi-point"
          [class.ri-focus-3-fill]="data.selected"
          [class.ri-focus-3-line]="!data.selected"
          [style.left.%]="box.leftPercent"
          [style.top.%]="box.topPercent"
          [style.color]="borderColor"
        ></i>
        <ng-template #roiBox>
          <div
            class="roi-box"
            [style.left.%]="box.leftPercent"
            [style.top.%]="box.topPercent"
            [style.width.%]="box.widthPercent"
            [style.height.%]="box.heightPercent"
            [style.borderColor]="borderColor"
          ></div>
        </ng-template>
      </ng-container>
    </div>
    <ts-badge badge [count]="data.additionalLabels" [loading]="data.loading"></ts-badge>
  </ts-image>
</div>
